class Wishlist {
  constructor() {
    console.log('Wishlist initialized'); // Debug
    this.storageKey = 'shopify-wishlist';
    this.wishlist = this.getWishlist();
    this.setupEventListeners();
    this.updateButtons();
  }

  setupEventListeners() {
    document.addEventListener('click', (event) => {
      const wishlistButton = event.target.closest('[data-wishlist-button]');
      if (wishlistButton) {
        console.log('Wishlist button clicked'); // Debug
        event.preventDefault(); // Prevent default behavior
        this.toggleWishlistItem(wishlistButton);
      }
    });

    // Update wishlist view if we're on the wishlist page
    if (document.querySelector('[data-wishlist-container]')) {
      this.renderWishlistPage();
    }
  }

  getWishlist() {
    const wishlist = localStorage.getItem(this.storageKey);
    console.log('Current wishlist:', wishlist); // Debug
    return wishlist ? JSON.parse(wishlist) : [];
  }

  saveWishlist() {
    localStorage.setItem(this.storageKey, JSON.stringify(this.wishlist));
    this.updateButtons();
  }

  toggleWishlistItem(button) {
    const productId = button.dataset.productId;
    const productHandle = button.dataset.productHandle;
    
    console.log('Toggle wishlist item:', { productId, productHandle }); // Debug

    if (!productId || !productHandle) {
      console.error('Missing product data attributes'); // Debug
      return;
    }

    const index = this.wishlist.findIndex(item => item.id === productId);

    if (index > -1) {
      this.wishlist.splice(index, 1);
      button.setAttribute('data-active', 'false');
      console.log('Product removed from wishlist'); // Debug
    } else {
      this.wishlist.push({
        id: productId,
        handle: productHandle
      });
      button.setAttribute('data-active', 'true');
      console.log('Product added to wishlist'); // Debug
    }

    this.saveWishlist();
    this.renderWishlistPage();
  }

  updateButtons() {
    const buttons = document.querySelectorAll('[data-wishlist-button]');
    buttons.forEach(button => {
      const productId = button.dataset.productId;
      const isInWishlist = this.wishlist.some(item => item.id === productId);
      button.setAttribute('data-active', isInWishlist.toString());
    });
  }

  formatMoney(cents) {
    // Use global formatMoney from currency-handler if available
    if (typeof window.formatMoney === 'function') {
      return window.formatMoney(cents);
    }
    
    // Fallback in case currency-handler is not available
    return (cents / 100).toLocaleString(Shopify.locale, {
      style: 'currency',
      currency: Shopify.currency.active,
      minimumFractionDigits: 2
    });
  }

  async renderWishlistPage() {
    const container = document.querySelector('[data-wishlist-products]');
    const emptyMessage = document.querySelector('[data-wishlist-empty]');
    
    if (!container || !emptyMessage) {
      console.error('Required elements not found:', { container, emptyMessage });
      return;
    }

    if (this.wishlist.length === 0) {
      container.innerHTML = '';
      emptyMessage.style.display = 'block';
      console.log('Wishlist is empty');
      return;
    }

    emptyMessage.style.display = 'none';
    container.innerHTML = '<p>Loading products...</p>';
    
    try {
      console.log('Starting to fetch products for wishlist items:', this.wishlist);

      const products = await Promise.all(
        this.wishlist.map(async item => {
          try {
            console.log(`Fetching product with handle: ${item.handle}`);
            const response = await fetch(`/products/${item.handle}.js`);
            
            if (!response.ok) {
              console.error(`Product fetch failed for ${item.handle}:`, response.status);
              return null;
            }

            const product = await response.json();
            console.log(`Successfully fetched product ${item.handle}:`, product);
            
            if (!product || !product.id) {
              console.error(`Invalid product data for ${item.handle}:`, product);
              return null;
            }

            return product;
          } catch (error) {
            console.error(`Error fetching product ${item.handle}:`, error);
            return null;
          }
        })
      );

      const validProducts = products.filter(product => product !== null);
      console.log(`Found ${validProducts.length} valid products out of ${products.length} total`);

      if (validProducts.length === 0) {
        container.innerHTML = '<p>Could not load the products from your wishlist. Please try again later.</p>';
        return;
      }

      container.innerHTML = validProducts.map(product => {
        const imageUrl = product.featured_image?.src || product.images[0] || '';
        const price = product.price;
        const description = product.description?.slice(0, 50) + (product.description?.length > 50 ? '...' : '') || '';
        
        console.log(`Rendering product ${product.handle} with price ${price}`);

        return `
          <div class="wishlist-product-card">
            <button
              class="wishlist-remove"
              data-wishlist-button
              data-product-id="${product.id}"
              data-product-handle="${product.handle}"
              aria-label="Remove from wishlist">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
              </svg>
            </button>
            <a href="/products/${product.handle}" class="wishlist-product-link">
              <div class="wishlist-product-image-container">
                <img 
                  src="${imageUrl}"
                  alt="${product.title}" 
                  class="wishlist-product-image"
                  loading="lazy"
                  onerror="this.src='//cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png'">
              </div>
              <div class="wishlist-product-content">
                <h3 class="wishlist-product-title">${product.title}</h3>
                <p class="wishlist-product-price" data-price data-original-price="${price}">
                  ${this.formatMoney(price)}
                </p>
                <p class="wishlist-product-description">${description}</p>
              </div>
            </a>
          </div>
        `;
      }).join('');

      if (typeof window.updatePrices === 'function') {
        window.updatePrices();
      }

      this.updateButtons();
    } catch (error) {
      console.error('Error general en renderWishlistPage:', error);
      container.innerHTML = '<p>An error occurred while loading products. Please refresh the page.</p>';
    }
  }
}

// Initialize wishlist when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  window.wishlist = new Wishlist(); // Make instance globally accessible
});
